import { Outlet } from "react-router-dom";
import CommonLayout from "../../pages/Layouts/CommonLayout";
import useMediaNews from "./useMediaNews";


const MediaNews = () => {
  const { drawerMenu } = useMediaNews();

  return (
    <CommonLayout drawerMenu={drawerMenu}>
      <Outlet />
    </CommonLayout>
  );
};

export default MediaNews;